// A value recalculated because of someone's change is underlined, never highlighted: the highlight marks only the
// fields a person changed (legend: highlight = "a field someone changed", dotted underline = "recalculated because
// of those changes"). sx resolves the color callback; a theme styleOverride passes its palette color instead.
export const getRecalculatedValueStyles = ({
  decorationColor = ({ palette }) => palette.text.secondary,
  underlineOffset = '3px',
} = {}) => ({
  textDecorationLine: 'underline',
  textDecorationStyle: 'dotted',
  textDecorationColor: decorationColor,
  textDecorationThickness: '1.5px',
  textUnderlineOffset: underlineOffset,
});
